module.exports = __webpack_public_path__ + "media/images/icon_a4-c13240a3c83c18a788e08bd39238fe4f.png";